import React, { useState, useMemo } from 'react';
import CalcShell, { StepsPanel } from '../CalcShell';
import { fmt } from './_finHelpers';

export default function DiscountCalc() {
  const [before, setBefore] = useState(59.99);
  const [discount, setDiscount] = useState(15);
  const [type, setType] = useState('percent');
  const c = useMemo(() => {
    const saved = type === 'percent' ? before * discount/100 : discount;
    const after = Math.max(0, before - saved);
    return { after, saved };
  }, [before, discount, type]);
  return (
    <CalcShell look="cnet" title="Discount Calculator" subtitle="Compute the sale price and dollar amount saved from a percentage-off or fixed-amount discount."
      about={<><p>A <b>discount</b> reduces the sticker price by either a fixed percentage (Percent off) or a fixed dollar amount (Fixed amount off).</p></>}
    >
      <p className="text-sm text-slate-600 mb-4">Please provide any 2 values below to calculate.</p>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="field"><label>Price before discount</label><div className="flex gap-2"><span className="self-center text-slate-500">$</span><input type="number" step="0.01" value={before} onChange={e=>setBefore(+e.target.value||0)} className="flex-1"/></div></div>
          <div className="field"><label>Discount</label><div className="flex gap-2"><input type="number" step="0.01" value={discount} onChange={e=>setDiscount(+e.target.value||0)} className="flex-1"/><span className="self-center text-slate-500">{type==='percent'?'%':'$'}</span></div></div>
          <div className="field"><label>Discount type</label>
            <div className="flex gap-4 mt-1 text-sm"><label><input type="radio" checked={type==='percent'} onChange={()=>setType('percent')}/> Percent off</label><label><input type="radio" checked={type==='fixed'} onChange={()=>setType('fixed')}/> Fixed amount off</label></div>
          </div>
        </div>
        <div>
          <table className="data-table"><tbody>
            <tr><td>Price after discount</td><td className="text-right font-semibold text-blue-700 text-lg" data-testid="disc-after">{fmt(c.after)}</td></tr>
            <tr><td>You saved</td><td className="text-right text-orange-600" data-testid="disc-saved">{fmt(c.saved)}</td></tr>
          </tbody></table>
        </div>
      </div>
    </CalcShell>
  );
}
